import { render, staticRenderFns } from "./FarmaciaLista.vue?vue&type=template&id=49f6a76b&"
import script from "./FarmaciaLista.vue?vue&type=script&lang=js&"
export * from "./FarmaciaLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports